import { render, staticRenderFns } from "./UpdatePacket.vue?vue&type=template&id=799ae520"
import script from "./UpdatePacket.vue?vue&type=script&lang=js"
export * from "./UpdatePacket.vue?vue&type=script&lang=js"
import style0 from "./UpdatePacket.vue?vue&type=style&index=0&id=799ae520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports